import { render, staticRenderFns } from "./OrgsEdit.vue?vue&type=template&id=224f1544&"
import script from "./OrgsEdit.vue?vue&type=script&lang=js&"
export * from "./OrgsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports